<template>
    <div class="modal-faq" role="dialog" aria-labelledby="faq-title" aria-describedby="faq-description">
        <header class="faq-header">
            <h2 id="faq-title" class="faq-title">Questions and Answers</h2>
            <p id="faq-description" class="faq-intro">Find answers to common questions below. We update this list regularly. You can also contact support or ask in our Discord.</p>
        </header>
        <div class="faq-list" role="list">

            <FaqElement title="What is Worldcupsports.casino?" text="Worldcupsports is a virtual arcade designed for Worldcupsports.casino players to multiply their Robux or Limiteds! We are the most innovative arcade, and we strive to bring you the best experiences." />
            <FaqElement title="Why do you need my Worldcupsports.casino credentials?" text="In order for us to automate our deposit and withdraw system, we utilize our P2P system to facilitate seamless transactions for depositors & withdrawers. Worldcupsports.casino ensures user security and we do not store your password. In any circumstances you feel unsafe with us having your credentials, you can simply invalidate them by changing your password on Worldcupsports.casino." />
            <FaqElement title="What are the coins?" text="Our balance is displayed as a coin, but it has a conversion rate of 1 coin to 1 Robux. We allow you to withdraw these coins to Worldcupsports.casino at a 1-to-1 rate." />
            <FaqElement title="Can I transfer coins to another account?" text="Yes, you can transfer coins to another account by simply clicking on a user's profile and clicking the Tip User button." />
            <FaqElement title="I am missing coins, what now?" text="Please ensure you've not given access to your Worldcupsports.casino account or your Worldcupsports.casino account. In the case you are compromised, we will assist you with regaining access to your account. Although, we do not issue balance adjustments to compensate for the loss, as your account security is your responsibility. If this involves a game issue, open a ticket in the discord." />
            <FaqElement title="I deposited with cryptocurrency and I still have not received my deposit." text="If you’ve still not received your deposit after 3 confirmations, please open a ticket inside our discord explaining the situation and providing transaction IDs." />
            <FaqElement title="I have discovered a vulnerability or an exploit, what now?" text="Join our discord and create a ticket. You will be rewarded for reporting any vulnerability or exploit." />
            <FaqElement title="What is Rain Abuse?" text="The rain coins distributed throughout the 30-minute rain feature are intended to be played with on the games provided on our site exclusively. Saving up free rain coins over an extended period of time and/or not using them to genuinely participate in the games provided is considered rain abuse and will result in a ban. Please note, all rain bans are permanent and will not be lifted." />
            <FaqElement title="How much commission do I get when my referrals place a bet?" text="Every time someone you've referred places a bet, you receive 1% of that overall wager. In the instance that someone wagers 1,000,000 coins, you'd receive 10,000." />
            <FaqElement title="How does wager contribution work for bonuses?" text="When completing bonus wagering requirements, your bets count toward the requirement at different rates depending on the game: Crash, Towers, and Blackjack count at 50%; Slots count at 100%; Mines count at 100% but only when you reach at least 1.4x multiplier (otherwise the round does not count toward the wager requirement)." />
            <FaqElement title="How does the deposit and withdrawal system work?" text="We use a Peer-to-Peer (P2P) system to facilitate the transactions on our site. In this case, there may be extended wait times for limited deposits and/or Robux deposits. In order to deposit, someone must withdraw, and vice versa. Worldcupsports.casino will subsidize long queue times to ensure user satisfaction." />
            <FaqElement title="Is there a maximum bet or profit?" text="Yes, each game has a maximum bet and a maximum profit allotted for each round. You can find it located inside each game." />
            <FaqElement title="What happens if my internet disconnects during a Crash round?" text="Whether your client is connected or disconnected, the auto-cashout feature will work as intended. We highly recommend you use this feature if your internet connection is faulty or if you have poor internet reliability." />
            <FaqElement title="Does the Crash game have a maximum multiplier?" text="Our Crash game has no limit! Although, you will be automatically cashed out if you hit our maximum profit." />
            <FaqElement title="How do I know that Worldcupsports.casino is fair & doesn't rig results?" text="Worldcupsports.casino is a provably fair casino. You can check all game results with our provably fair system, found at the bottom of our website." />
            <FaqElement title="Can I make money by promoting the website?" text="If you're an influencer who is looking to be sponsored by us, please join our Discord server and open a ticket. You can link your discord in the 'Settings' page, inside your profile." />

        </div>
    </div>
</template>

<script>
    import FaqElement from '@/components/faq/FaqElement';

    export default {
        name: 'ModalFaq',
        components: {
            FaqElement
        }
    }
</script>

<style scoped>
    .modal-faq {
        width: 100%;
        max-width: 720px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 32px 32px 24px;
        border-radius: 16px;
        background: var(--bg-purple-dark);
        box-shadow: 0 24px 48px rgba(0, 0, 0, 0.4);
    }

    .faq-header {
        width: 100%;
        padding-bottom: 24px;
        margin-bottom: 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }

    .faq-title {
        margin: 0;
        font-size: 24px;
        font-weight: 800;
        letter-spacing: 0.5px;
        color: #fff;
        line-height: 1.25;
    }

    .faq-intro {
        margin: 12px 0 0;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.5;
        color: #9ca3af;
    }

    .faq-list {
        width: 100%;
        max-height: min(70vh, 520px);
        padding: 8px 4px 8px 0;
        overflow-x: hidden;
        overflow-y: auto;
        scroll-behavior: smooth;
    }

    .faq-list::-webkit-scrollbar {
        width: 6px;
    }

    .faq-list::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px;
    }

    .faq-list::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 3px;
    }

    .faq-list::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
    }

    @media only screen and (max-width: 768px) {
        .modal-faq {
            max-width: calc(100vw - 24px);
            padding: 24px 20px 20px;
        }

        .faq-title {
            font-size: 20px;
        }

        .faq-intro {
            font-size: 13px;
        }

        .faq-list {
            max-height: 60vh;
        }
    }
</style>
